module.exports = __webpack_public_path__ + "img/wedss6.30f5f384.jpg";